<template>
  <div>
    <p class="px-2 pt-2 p-md-0 mb-0 intro-text">
      <small>
        Вітаємо! Ви молоді батьки або готуєтеся ними стати? У вас народилися малюки і
        вони ще не ходять до школи? А може ви – бабусі та дідусі і маєте веселих
        невгамовних онуків? Тоді вам точно до нас!
      </small>
    </p>

    <PostLister></PostLister>
  </div>
</template>

<script>
import PostLister from '@/components/Posts/Lister/PostLister'

export default {
  name: 'HomePage',
  components: {
    PostLister
  }
}
</script>

<style lang="scss" scoped>
  @import "../../common.scss";

  .intro-text {
    line-height: 1.3em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/HomePage.vue